import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/* Author Routes */
import { FeaturesComponent } from './features/features.component';
import { CartSuccessComponent } from './features/cart-success/cart-success.component';
import { FeaturesCartCheckoutComponent } from './features/features-cart-checkout/features-cart-checkout.component';
import { FeaturesStep1Component } from './features/features-step1/features-step1.component';
import { FeaturesStep2Component } from './features/features-step2/features-step2.component';
import { FeaturesStep3Component } from './features/features-step3/features-step3.component';
import { FeaturesStep4Component } from './features/features-step4/features-step4.component';
import { FeaturesStep5Component } from './features/features-step5/features-step5.component';

/* Guards */
import { CanDeactivateGuard } from '../core/guards/can-deactivate.guard';

const routes: Routes = [
	{
		path: '',
		component: FeaturesComponent,
		canDeactivate: [CanDeactivateGuard],
		children: [
			// DynamicContainerComponent works with ABTest class to load a control
			// or experimental component based on the result of the DynamicContainerComponent.controller() method.

			// To remove AB testing, the route can be changed to load the control component.
			// Alternatively the DynamicContainerComponent.controller() method can be changed to always return true.
			{
				path: 'order-checkout/:orderId/success',
				component: CartSuccessComponent,
				title: 'Payment Success',
			},
			{
				path: 'order-checkout/:orderId',
				component: FeaturesCartCheckoutComponent,
				canDeactivate: [CanDeactivateGuard],
				title: 'Checkout',
			},
			{
				path: ':siteSlug',
				component: FeaturesStep2Component,
				title: 'Features - Step 2',
			},
			{
				path: ':siteSlug/:siteAdvertSlug',
				component: FeaturesStep3Component,
				title: 'Features - Step 3',
			},
			{
				path: ':siteSlug/:siteAdvertSlug/:pubDate',
				component: FeaturesStep4Component,
				title: 'Features - Step 4',
			},
			{
				path: ':siteSlug/:siteAdvertSlug/checkout/:featuredBookId',
				component: FeaturesStep5Component,
				title: 'Features - Step 5',
			},
			{
				path: '',
				component: FeaturesStep1Component,
				title: 'Features - Step 1',
			},
		],
	},
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
